import * as React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import { useCurrencyFormatter } from 'hooks/useCurrencyFormatter';
import { ServiceShape } from 'lib/util/productShape';
import { printPriceTitle } from 'lib/util/util';
import { LinkableTextArea } from 'components/LinkableTextArea/LinkableTextArea';

interface Props {
  services: ServiceShape[];
  hideOverThresholdServices?: boolean;
  threshold?: number;
  showAllText?: string;
}

export const ServiceList = ({
  services,
  hideOverThresholdServices,
  threshold,
  showAllText,
}: Props) => {
  const { t } = useTranslation();

  const currencyFormatter = useCurrencyFormatter();

  const [showAll, setShowAll] = React.useState(false);

  return (
    <ul className="c-schedule2">
      {services.map((service, idx) => {
        const showDescription = !!service.description;

        if (hideOverThresholdServices && threshold) {
          if (!showAll && idx === threshold) {
            return (
              <li key={service.name} className="c-schedule2__list">
                <a className="c-schedule2__show_more" onClick={() => setShowAll(true)}>
                  {showAllText || t('Show All')}
                </a>
              </li>
            );
          }
          if (!showAll && idx >= threshold) {
            return null;
          }
        }

        return (
          <li key={service.name} className="c-schedule2__list">
            <p className="c-schedule2__list__item__title">{service.name}</p>
            <div className="c-schedule2__list__item__body">
              {showDescription && (
                <div className="c-schedule2__list__item__body__text">
                  <div className="c-schedule2__list__item__body__text__th">
                    {t('[Description]')}
                  </div>
                  <div className={clsx('c-schedule2__list__item__body__text__td', 'newline')}>
                    <LinkableTextArea>{service.description}</LinkableTextArea>
                  </div>
                </div>
              )}
              <div className="c-schedule2__list__item__body__price">
                <div className="c-schedule2__list__item__body__price__th">{t('[Price]')}</div>
                {service.type === 'FREE' ? (
                  <div className="c-schedule2__list__item__body__price__td">{t('Free')}</div>
                ) : (
                  <div className="c-schedule2__list__item__body__price__td">
                    {service.pricesSummary.map((price) => (
                      <p key={price.unitTitle}>
                        <span>{printPriceTitle(price, t)}</span>
                        {currencyFormatter.format(price.amount)}
                      </p>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  );
};
